import { render, staticRenderFns } from "./AccountSelector.vue?vue&type=template&id=52fe3671&scoped=true"
import script from "./AccountSelector.vue?vue&type=script&lang=js"
export * from "./AccountSelector.vue?vue&type=script&lang=js"
import style0 from "./AccountSelector.vue?vue&type=style&index=0&id=52fe3671&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe3671",
  null
  
)

export default component.exports